import React from 'react';
import { Rocket, Zap, Shield, Lock, Clock } from 'lucide-react';

const ChatGPTCTA = ({ onGetStarted }) => {
 return (
 <section className="py-20 bg-black text-white">
 <div className="container mx-auto px-4 text-center">
 <div className="max-w-3xl mx-auto">
 <h2 className="text-4xl md:text-5xl font-bold mb-6">
 Ready to Get ChatGPT Plus Access?
 </h2>
 
 <p className="text-xl mb-12 opacity-90">
 Join thousands of users who've already made the smart choice for affordable ChatGPT Plus access
 </p>
 
 <button
 onClick={onGetStarted}
 className="bg-white text-black px-12 py-5 rounded-lg text-xl font-semibold hover:bg-cream-100 transition-colors duration-200 inline-flex items-center mb-12"
 >
 <Rocket className="mr-3 w-5 h-5" />
 Get ChatGPT Plus Now →
 </button>
 
 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-4xl mx-auto">
 <div className="text-center">
 <div className="text-white mb-3 flex justify-center">
 <Zap className="w-8 h-8" />
 </div>
 <h3 className="font-semibold mb-2">Instant Access</h3>
 <p className="text-sm opacity-80">ChatGPT Plus ready in 5 minutes</p>
 </div>
 
 <div className="text-center">
 <div className="text-white mb-3 flex justify-center">
 <Shield className="w-8 h-8" />
 </div>
 <h3 className="font-semibold mb-2">Bank-Level Security</h3>
 <p className="text-sm opacity-80">256-bit SSL & secure processing</p>
 </div>
 
 <div className="text-center">
 <div className="text-white mb-3 flex justify-center">
 <Lock className="w-8 h-8" />
 </div>
 <h3 className="font-semibold mb-2">Complete Data Isolation</h3>
 <p className="text-sm opacity-80">Zero cross-contamination</p>
 </div>
 
 <div className="text-center">
 <div className="text-white mb-3 flex justify-center">
 <Clock className="w-8 h-8" />
 </div>
 <h3 className="font-semibold mb-2">24/7 Support & Monitoring</h3>
 <p className="text-sm opacity-80">Always available assistance</p>
 </div>
 </div>
 
 <div className="mt-16 p-8 border border-ink-700 rounded-lg max-w-2xl mx-auto">
 <h3 className="text-2xl font-semibold mb-4">Limited Time Offer</h3>
 <p className="text-lg mb-6 opacity-90">
 Lock in our current promotional pricing before rates increase
 </p>
 <div className="flex flex-wrap justify-center gap-6 text-sm">
 <span className="flex items-center">
 <Zap className="mr-2 w-4 h-4" />
 Instant activation
 </span>
 <span className="flex items-center">
 <Shield className="mr-2 w-4 h-4" />
 30-day guarantee
 </span>
 <span className="flex items-center">
 <Lock className="mr-2 w-4 h-4" />
 Secure payment
 </span>
 <span className="flex items-center">
 <Clock className="mr-2 w-4 h-4" />
 24/7 support
 </span>
 </div>
 </div>
 </div>
 </div>
 </section>
 );
};

export default ChatGPTCTA;